import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApplicationReloader {
  reloadToRoot(): void {
    window.location.href = window.location.origin;
  }

  reloadToCurrentUrl(): void {
    window.location.reload();
  }
}
